import React from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';

interface DiscardChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

export const DiscardChangesModal = ({ isOpen, onClose, onDiscard }: DiscardChangesModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalContent>
      <ModalHeader>
        {appTranslate('discard_changes_modal.title')}
        <ModalCloseBtn />
      </ModalHeader>
      <ModalBody>
        <Text>{appTranslate('discard_changes_modal.description')}</Text>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose}>
          {appTranslate('discard_changes_modal.cancel')}
        </Button>
        <Button onClick={onDiscard}>{appTranslate('discard_changes_modal.confirm')}</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
